import { useContext, useState, useEffect } from "react";
import { useBeforeUnload } from "react-router-dom";
import { AppContext } from "../../root/Root";
import { Button } from "@mui/material";
import { DefaultLayout } from "../../../layouts/DefaultLayout";
import Grid from "@mui/material/Unstable_Grid2";
import {
  BookmarkBorderOutlined,
  BookmarksOutlined,
  BlockOutlined,
} from "@mui/icons-material";

import { AppAlert } from "../../../components/common/appAlert/AppAlert";
import { DataAssignment } from "../../../components/eRetail/dataAssignment/DataAssignment";

import useBuyersData from "../../../hooks/eRetail/useBuyersData";
import useBuyerStatus from "../../../hooks/eRetail/useBuyerStatus";

import { initLocalization } from "../../../utils/helpers";
import { actionButtonsStrings } from "./locale";
import { BUYERS_STATUSES } from "../../../constants";
import "../../../style/common.scss";

export const Level1 = () => {
  useContext(AppContext);

  initLocalization(actionButtonsStrings);

  const [selectedBuyers, setSelectedBuyers] = useState([]);

  const { lockBuyerLines } = useBuyersData();
  const {
    isLoading: statusLoading,
    error,
    success,
    setBuyersStatus,
    setError,
  } = useBuyerStatus();

  const disableButtons = () => {
    return !selectedBuyers?.length || statusLoading;
  };

  const buildPayload = () => {
    const payload = {
      buyerIds: selectedBuyers.map((row) => row.id),
    };

    return payload;
  };

  const handleExclude = () => {
    setBuyersStatus(BUYERS_STATUSES.exclude, buildPayload());
  };

  const handleSetBrand = () => {
    setBuyersStatus(BUYERS_STATUSES.brand, buildPayload());
  };

  const handleSetReseller = () => {
    setBuyersStatus(BUYERS_STATUSES.reseller, buildPayload());
  };

  const handleCloseError = () => setError(false);

  // Unlock lines on unmount and page unload
  useEffect(() => {
    return () => {
      lockBuyerLines({
        shouldLock: false,
      });
    };
  }, []);

  useBeforeUnload(() => {
    lockBuyerLines({
      shouldLock: false,
    });
  });

  return (
    <DefaultLayout>
      <AppAlert
        key={error}
        open={Boolean(error)}
        type="error"
        onClose={handleCloseError}
      >
        {actionButtonsStrings.errors[error]}
      </AppAlert>

      <Grid
        className="page-content"
        container
        rowSpacing={{ xs: 3, md: 0 }}
        columnSpacing={{ xs: 0, md: 2 }}
        padding={{ xs: 1, md: 2 }}
        disableEqualOverflow
      >
        <Grid xs={12}>
          <Grid container direction="column" columns={12} height="100%">
            <Grid xs={12} flexGrow="1">
              <DataAssignment
                isLoading={statusLoading}
                shouldRefresh={success}
                onBuyersSelection={setSelectedBuyers}
              />
            </Grid>
            <Grid
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              gap={2}
              smOffset="auto"
              paddingY={3}
            >
              <Button
                startIcon={<BlockOutlined />}
                variant="outlined"
                color="error"
                size="large"
                disabled={disableButtons()}
                onClick={handleExclude}
              >
                {actionButtonsStrings.exclude}
              </Button>
              <Button
                startIcon={<BookmarkBorderOutlined />}
                variant="outlined"
                color="success"
                size="large"
                disabled={disableButtons()}
                onClick={handleSetBrand}
              >
                {actionButtonsStrings.brand}
              </Button>
              <Button
                startIcon={<BookmarksOutlined />}
                variant="outlined"
                color="success"
                size="large"
                disabled={disableButtons()}
                onClick={handleSetReseller}
              >
                {actionButtonsStrings.reseller}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </DefaultLayout>
  );
};
